import {
  ChartConfig,
  ChartContainer,
  ChartTooltip,
  ChartTooltipContent,
} from "@/components/ui/chart";
import { Cell, Legend, Pie, PieChart } from "recharts";

import ChartWrapper from "@/components/common/ChartWrapper";

import { CustomLegendProps } from "@/types/common.types";
import { COLORS } from "@/lib/constants";
import { useGetInventoryDistributionQuery } from "@/hooks/queries";
const chartConfig: ChartConfig = {
  value: {
    label: "Inventory Distribution",
    color: "#1A5BFA",
  },
};
export default function ArticleTypeChart({
  jobId,
  date,
}: {
  jobId: string;
  date: string;
}) {
  const {
    data: inventoryDistributionData,
    isLoading: inventoryDistributionDataLoading,
  } = useGetInventoryDistributionQuery({
    jobId: jobId,
    date: date,
  });

  const CustomLegend = (props: CustomLegendProps) => {
    const { payload } = props;

    return (
      <div className="mt-4 flex flex-wrap justify-center gap-4">
        {payload?.map((entry, index: number) => (
          <div key={`legend-${index}`} className="flex items-center gap-2">
            <div
              className="h-3 w-3 rounded-full"
              style={{ backgroundColor: entry.color }}
            />
            <span className="text-xs text-muted-foreground">{entry.value}</span>
          </div>
        ))}
      </div>
    );
  };

  const chartData = inventoryDistributionData?.articleType;

  return (
    <ChartWrapper
      title="Article Type"
      isLoading={inventoryDistributionDataLoading}
      className="flex-1"
      hasInfoIcon
      infoText="The inventory distribution of insights for a given colour."
    >
      <ChartContainer
        config={chartConfig}
        className="aspect-auto h-[350px] w-full pb-6"
      >
        <PieChart width={1000} height={1000}>
          <ChartTooltip
            content={
              <ChartTooltipContent
                className="w-[150px]"
                formatter={(value, name) => (
                  <div className="flex w-full items-center justify-between text-xs text-muted-foreground">
                    <span>{name}</span>
                    <span>{value}</span>
                  </div>
                )}
                hideIndicator
              />
            }
          />
          <Pie
            data={chartData}
            dataKey="value"
            nameKey="type"
            // label={(entry) => entry.type}
            innerRadius={60}
            isAnimationActive={false}
          >
            {chartData?.map((_, index) => (
              <Cell
                key={`cell-${index}`}
                fill={COLORS[index % COLORS.length]}
              />
            ))}
          </Pie>
          <Legend
            content={(props) => <CustomLegend {...props} />}
            verticalAlign="bottom"
            height={36}
          />
        </PieChart>
      </ChartContainer>
    </ChartWrapper>
  );
}
